import { ICalculateResponsiveStateAction } from 'redux-responsive/types';
import { LocationChangeAction } from 'connected-react-router';

// Exports all actions for the module
export enum TYPES {
  TOGGLE_MENU = '[APP]-TOGGLE_MENU',
  // This is the LOCATION_CHANGE action type from connected-react-router
  LOCATION_CHANGE = '@@router/LOCATION_CHANGE',
  // Redux-responsive doesn't expose the action string
  REDUX_RESPONSIVE_STATE = 'redux-responsive/CALCULATE_RESPONSIVE_STATE',

  SHOW_MODAL = '[APP]-SHOW_MODAL',
  HIDE_MODAL = '[APP]-HIDE_MODAL',
}

export interface IToggleMenu {
  type: typeof TYPES.TOGGLE_MENU;
  payload: null;
}

export type AppActions = IToggleMenu | LocationChangeAction | ICalculateResponsiveStateAction | IShowModal | IHideModal;

// ACTIONS
export function toggleMenuAction(): IToggleMenu {
  return {
    type: TYPES.TOGGLE_MENU,
    payload: null,
  };
}

// =====================
// Show modal action
// =====================
export interface IShowModal {
  type: typeof TYPES.SHOW_MODAL;
  payload: {};
}

export function actionShowModal(): IShowModal {
  return {
    type: TYPES.SHOW_MODAL,
    payload: {},
  };
}

// =====================
// Hide modal action
// =====================
export interface IHideModal {
  type: typeof TYPES.HIDE_MODAL;
  payload: {};
}

export function actionHideModal(): IHideModal {
  return {
    type: TYPES.HIDE_MODAL,
    payload: {},
  };
}
